// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"dc4b57b6","297":"d31e6821","643":"10d7a17a","787":"4c1f999c","959":"7e02a016"}[chunkId] + ".chunk.js";
};